import { create } from 'zustand'
import keycloak from '../../keycloak'

export const useAuthStore = create((set, get) => ({
  user: null,
  token: null,
  isInitialized: false,
  initializeKeycloak: async () => {
    if (get().isInitialized || !keycloak) {
      return
    }

    try {
      const currentUrl = window.location.origin + window.location.pathname + window.location.search

      const initialized = await keycloak.init({
        onLoad: 'check-sso',
        checkLoginIframe: false,
        redirectUri: currentUrl,
        pkceMethod: 'S256',
      })

      if (initialized && keycloak.authenticated) {
        set({
          user: keycloak.tokenParsed,
          token: keycloak.token || null,
        })
      } else {
        set({ user: null, token: null })
      }
    } catch (error) {
      console.error('Erro na inicialização do Keycloak:', error)
    } finally {
      set({ isInitialized: true })
    }
  },
  logout: () => {
    set({ user: null, token: null, isInitialized: false })
    const logoutRedirectUri = window.location.origin + '/login'
    keycloak?.logout({ redirectUri: logoutRedirectUri })
  },
}))
